module.exports = __webpack_public_path__ + "static/media/mg.9dc1916f.svg";